import { AbstractDataProviderV2, IDataProviderV2 } from 'components/system';
import {
    CustomerActivityAdd,
    CustomerActivityAddWithType,
    CustomerActivityUpdate,
    RsCustomerActivity,
    RsCustomerActivityInfo
} from 'common/customers/services/types';

export interface ICustomerActivityDataProvider
    extends IDataProviderV2<RsCustomerActivity, RsCustomerActivityInfo, CustomerActivityAdd, CustomerActivityUpdate> {
    addWithType(params: CustomerActivityAddWithType): Promise<RsCustomerActivityInfo>;
}

export class CustomerActivityDataProvider
    extends AbstractDataProviderV2<RsCustomerActivity, RsCustomerActivityInfo, CustomerActivityAdd, CustomerActivityUpdate>
    implements ICustomerActivityDataProvider
{
    constructor() {
        super();
        this.setApiUrl('middle://rs/activity/customer-activities');
    }

    patch(): Promise<null> {
        return Promise.reject('Method is not supported');
    }

    addWithType(params: CustomerActivityAddWithType): Promise<RsCustomerActivityInfo> {
        const url = this.apiUrl + '/activity-type';
        return this.service.updateRequest(url, this.addMethod, params);
    }
}
